import { render, staticRenderFns } from "./related_question.vue?vue&type=template&id=312350d8&scoped=true&"
import script from "./related_question.vue?vue&type=script&lang=js&"
export * from "./related_question.vue?vue&type=script&lang=js&"
import style0 from "./related_question.vue?vue&type=style&index=0&id=312350d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312350d8",
  null
  
)

export default component.exports